module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3u9Ex"))).then(() => module.bundle.root('jnagv'));